import React, { Component } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { withRouter, Link } from "react-router-dom";

import {
  load,
  setFiltro,
  buscar,
  remove,
  adicionar,
  qsort,
} from "../../actions/acesso/CoAcesso";
import { load as loadAcesso } from "../../actions/acesso/CadAcesso";

import { Carregando, Alert } from "../../components";

import { CadAcesso } from "./";

class CoAcesso extends Component {
  componentWillMount() {
    this.carregar();
  }

  render() {
    let { expressao, isFetching } = this.props;

    return (
      <span>
        <Alert
          ref={(ref) => {
            this._alert = ref;
          }}
        />
        <CadAcesso
          afterSave={(data) => {
            this.adicionar(data);
          }}
        />
        <Carregando isOpen={isFetching} />
        <div className="pt-callout .modifier">
          <h5>Senha de ativação dispositivo</h5>
        </div>
        <nav className="pt-navbar .modifier">
          <div className="pt-navbar-group pt-align-left">
            <div className="pt-navbar-heading">Expressão para consulta:</div>
            <input
              className="pt-input"
              placeholder="Buscar..."
              type="text"
              value={expressao}
              onChange={({ target }) => {
                this.setFiltro({ expressao: target.value });
              }}
            />
            <span className="pt-navbar-divider"></span>
            <button
              className="pt-button pt-intent-primary"
              onClick={() => {
                this.buscar();
              }}
            >
              Consultar
            </button>
            <span className="pt-navbar-divider"></span>
            <button
              className="pt-button"
              onClick={() => {
                this.novo();
              }}
            >
              Novo
            </button>
          </div>
          <div className="pt-navbar-group pt-align-right"></div>
        </nav>
        <div className="pt-card .modifier">
          <table className="pt-table pt-striped pt-interactive" width="100%">
            <thead>
              <tr>{this.renderTableHead()}</tr>
            </thead>
            <tbody>{this.renderDataSource()}</tbody>
          </table>
        </div>
        <div className="pt-callout pt-intent-primary">
          <h5>Senha para limpar base</h5>
          Total = {this.getSenhaTotal()} | Parcial (manter pedidos) ={" "}
          {this.getSenhaParcial()}
        </div>
      </span>
    );
  }

  renderTableHead() {
    let { sort } = this.props;

    let head = [
      { key: "#", label: "#" },
      { key: "group", label: "Conta", onClick: () => this.qsort("group") },
      { key: "name", label: "Nome", onClick: () => this.qsort("name") },
      {
        key: "client_key",
        label: "Senha de ativação",
        onClick: () => this.qsort("client_key"),
      },
      { key: "appType", label: "Tipo" },
      { key: "default_licenses", label: "Licenças contratadas" },
      { key: "additional_licenses", label: "Licenças adicionais" },
      { key: "used_licenses", label: "Licenças utilizadas" },
      { key: "remain_licenses", label: "Licenças disponiveis" },
      { key: "dispositivos", label: "Dispositivos" },
      { key: "alterar", label: "Alterar" },
      { key: "excluir", label: "Excluir" },
    ];

    let icon = <span className="pt-icon pt-icon-caret-up" />;
    if (sort.asc) {
      icon = <span className="pt-icon pt-icon-caret-down" />;
    }

    return head.map((item, index) => {
      return (
        <th
          key={index}
          onClick={item.onClick}
          style={{ cursor: item.onClick ? "pointer" : "default" }}
        >
          {item.label} {sort.property === item.key ? icon : null}
        </th>
      );
    });
  }

  renderDataSource() {
    let { dataSource } = this.props;

    if (dataSource && dataSource.length > 0) {
      return dataSource.map((item, index) => {
        let appType =
          item.external_url.includes("api/app") ||
          item.internal_url.includes("api/app")
            ? "ON"
            : "OFF";
        let disponiveis =
          parseInt(item.default_licenses, 10) +
          parseInt(item.additional_licenses, 10) -
          parseInt(item.used_licenses, 10);
        return (
          <tr key={item.id}>
            <td>{index + 1}</td>
            <td>{item.group}</td>
            <td>{item.name}</td>
            <td>{item.client_key}</td>
            <td style={{ color: appType === "ON" ? "green" : "red" }}>
              {appType}
            </td>
            <td>{item.default_licenses}</td>
            <td>{item.additional_licenses}</td>
            <td>{item.used_licenses}</td>
            <td>{disponiveis}</td>
            <td>
              <Link to={`/main/${item.client_key}/devices`}>Dispositivos</Link>
            </td>
            <td>
              <a
                onClick={() => {
                  this.alterar(item);
                }}
              >
                Alterar
              </a>
            </td>
            <td>
              <a
                onClick={() => {
                  this.excluir(item.id);
                }}
              >
                Excluir
              </a>
            </td>
          </tr>
        );
      });
    }

    return (
      <tr key="vazio">
        <td colSpan="11">Nenhum registro encontrado!</td>
      </tr>
    );
  }

  getSenhaTotal() {
    let data = new Date();
    return parseInt((data.getDate() * 301) / 57, 10);
  }

  getSenhaParcial() {
    let data = new Date();
    return parseInt((data.getDate() * 101) / 55, 10);
  }

  setFiltro(value) {
    this.props.setFiltro(value);
  }

  buscar() {
    this.carregar().then(() => {
      this.props.buscar();
    });
  }

  qsort(property) {
    this.props.qsort(property);
  }

  novo() {
    this.props.loadAcesso();
  }

  alterar(acesso) {
    this.props.loadAcesso(acesso);
  }

  adicionar(data) {
    this.props.adicionar(data);
  }

  excluir(id) {
    this.props
      .remove(id)
      .then(() => {
        this.props.buscar();
      })
      .catch((error) => {
        this._alert.show({
          title: error.message,
          icon: "pt-icon-issue",
        });
      });
  }

  carregar() {
    return this.props.load().catch((error) => {
      this._alert.show({
        title: error.message,
        icon: "pt-icon-issue",
      });
    });
  }
}

function mapStateToProps(state) {
  let { dataSource, expressao, isFetching, sort } = state.coAcesso;

  return {
    dataSource,
    expressao,
    isFetching,
    sort,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { load, setFiltro, buscar, loadAcesso, remove, adicionar, qsort },
    dispatch,
  );
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CoAcesso),
);



// WEBPACK FOOTER //
// ./src/scenes/acesso/CoAcesso.js